import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { Logo } from "@/components/Layout";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const { register, googleLogin } = useAuth();
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await register(email, password, name); toast.success("Welcome to PLAYA"); nav("/dashboard"); }
    catch (err) { toast.error(err.response?.data?.detail || "Registration failed"); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center py-16">
      <div className="w-full max-w-md glass rounded-2xl p-10">
        <div className="text-center mb-8"><Logo /></div>
        <h1 className="font-display text-3xl font-semibold text-center">Create your account</h1>
        <form onSubmit={submit} className="mt-8 space-y-4">
          <input data-testid="reg-name" required placeholder="Full name" value={name} onChange={(e) => setName(e.target.value)} />
          <input data-testid="reg-email" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="reg-password" required type="password" placeholder="Password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)} />
          <button data-testid="reg-submit" disabled={busy} className="btn-gold w-full justify-center">{busy ? "Creating…" : "Create Account"}</button>
        </form>
        <div className="my-6 flex items-center gap-3 text-xs text-gray-500"><div className="flex-1 h-px bg-white/10" />OR<div className="flex-1 h-px bg-white/10" /></div>
        <button data-testid="google-register" onClick={googleLogin} className="btn-ghost w-full justify-center">Continue with Google</button>
        <p className="text-sm text-gray-400 text-center mt-6">Already have an account? <Link to="/login" className="text-[#D4AF37]">Sign in</Link></p>
      </div>
    </div>
  );
}
